import { LicenceApplicationStatuses } from "../../../../../api/LicenceDetails";
import { MakeSubmissionOrObjection } from "../MakeSubmissionOrObjection";
import { GetAppTrackerLabel } from "../ApplicationTrackerUtils";
import { DynamicApplicationTracker } from "./DynamicApplicationTracker";
import { ILicenceApplicationTrackerProps } from "./ILicenceApplicationTrackerProps";
import { TrackerCard } from "../TrackerCard";
import { TrackerText } from "./TrackerText";

export const WasteWaterAppTrackerDesktop = ({
  licence,
  licenceProfile,
}: ILicenceApplicationTrackerProps) => {
  const underAssessment =
    licence.lastatus ===
    LicenceApplicationStatuses.UnderAssessmentRequestForInformationOutstanding
      ? {
          value:
            LicenceApplicationStatuses.UnderAssessmentRequestForInformationOutstanding,
          label: LicenceApplicationStatuses.UnderAssessment,
        }
      : {
          value: LicenceApplicationStatuses.UnderAssessment,
          label: LicenceApplicationStatuses.UnderAssessment,
        };

  const availableStatuses = [
    {
      value: LicenceApplicationStatuses.ApplicationReceived,
      label: LicenceApplicationStatuses.ApplicationReceived,
    },
    underAssessment,
    {
      value: LicenceApplicationStatuses.ApplicationCompliance,
      label: LicenceApplicationStatuses.ApplicationCompliance,
    },
    {
      value: LicenceApplicationStatuses.AuthorisationIssued,
      label: LicenceApplicationStatuses.AuthorisationIssued,
    },
  ];

  const availableValues = availableStatuses.map((kv) => kv.value);
  const isTrackerVisible = availableValues.includes(licence.lastatus);

  var bodyElements = (
    <div>
      <MakeSubmissionOrObjection
        licence={licence}
        licenceProfile={licenceProfile}
      />
      {isTrackerVisible && (
        <DynamicApplicationTracker
          availableStatuses={availableStatuses}
          currentStatus={licence.lastatus}
        />
      )}
      <TrackerText licence={licence} licenceProfile={licenceProfile} />
    </div>
  );

  return (
    <TrackerCard
      title={GetAppTrackerLabel({ licence, licenceProfile })}
      content={bodyElements}
    />
  );
};
